import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Modal } from 'antd';
import { initEditorPhoneModalData } from '../../../constans/controlToolbar';
import { addPhone, editPhone } from '../../../utils/changeEditorPhoneFns';

const ChangeEditorPhoneModalNode = ({ form, phoneModal, editor }) => {
  const { getFieldDecorator, resetFields, validateFieldsAndScroll } = form;
  const { editorStateSelector, setEditorState} = editor;
  const { editorPhoneModalDataSelector, setEditorPhoneModalData } = phoneModal;

  const dispatch = useDispatch();
  const { visible, phone, dopPhone, text, editMode } = useSelector(
    editorPhoneModalDataSelector
  );
  const editorState = useSelector(editorStateSelector);

  const handleCancel = () => {
    dispatch(setEditorPhoneModalData(initEditorPhoneModalData));
    resetFields();
  };

  const handleOk = (e) => {
    e.preventDefault();
    validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { text, phone, dopPhone } = values;

        const textToInsert = text && text.trim() !== '' ? text : dopPhone ? `${phone}p${dopPhone}` : phone;
        
        const data = {
          editorState,
          textToInsert,
          phone: phone.split(' ').join(''),
          dopPhone,
        };

        const newEditorState = editMode ? editPhone(data) : addPhone(data);

        dispatch(setEditorState(newEditorState));

        handleCancel();
      }
    });
  };

  return (
    <Modal visible={visible} onOk={handleOk} onCancel={handleCancel}>
      <Form>
        <Form.Item
          label={editorState.getSelection().isCollapsed() ? 'Текст' : ''}
        >
          {getFieldDecorator('text', {
            initialValue: text || '',
          })(
            <Input
              placeholder="Введите текст номера телефона..."
              disabled={!editorState.getSelection().isCollapsed()}
              hidden={!editorState.getSelection().isCollapsed()}
            />
          )}
        </Form.Item>

        <Form.Item label="Телефон">
          {getFieldDecorator('phone', {
            initialValue: phone || '',
            rules: [
              { required: true, message: 'Пожалуйста, введите номер телефона.' },
              { pattern: new RegExp(/^[\d\+\()][\d\(\)\ -]{4,14}\d$/), message: 'Пожалуйста, введите корректный номер телефона.' }
            ], 
          })(<Input placeholder="Введите номер телефона..." />)}
        </Form.Item>

        <Form.Item label="Добавочный номер">
          {getFieldDecorator('dopPhone', {
            initialValue: dopPhone || '',
            rules: [
              { pattern: new RegExp(/^\d+$/), message: 'Пожалуйста, введите корректный добавочный номер.' }
            ], 
          })(<Input placeholder="Введите добавочный номер без решетки..." />)}
        </Form.Item>
      </Form>
    </Modal>
  );
}

const ChangeEditorPhoneModal = Form.create({ name: 'change_editor_phone' }) (
  ChangeEditorPhoneModalNode
)

export default ChangeEditorPhoneModal;